export default {
  strict: true,
  namespaced: true,
  state: {
    notes: {
      list: [],
      pageNum: 0,
      pageSize: 20,
      isMax: false,
      noteDeleteId: 0
    }
  },
  mutations: {
    resetNotes (state) {
      state.notes.list = []
      state.notes.pageNum = 0
    },
    addNotes (state, value) {
      state.notes.list.push(value)
    },
    setNotesPage (state, value) {
      state.notes.pageNum = value
    },
    setNotesIsMax (state, value) {
      state.notes.isMax = value
    },
    addNewNotes (state, value) {
      state.notes.list.unshift(value)
    },
    setNoteDeleteId (state, value) {
      state.notes.noteDeleteId = value
    },
    updateNote (state, value) {
      let i = state.notes.list.findIndex(x => x.id === value.id)
      if (i !== -1) {
        state.notes.list[i].message = value.message
        state.notes.list[i].status = value.status
      }
    },
    deleteNote (state, value) {
      let i = state.notes.list.findIndex(x => x.id === value)
      if (i !== -1) {
        state.notes.list.splice(i, 1)
      }
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/provider/notes.js